import { gql } from '@apollo/client'

export const EXPORT_PRODUCE_QUERY = gql`
  query TaxonomyProduceFunctionalUnits(
    $first: Int
    $after: String
    $where: TaxonomyProduceFunctionalUnitsGraphQLFilterInput
    $order: [TaxonomyProduceFunctionalUnitsGraphQLSortInput!]
  ) {
    taxonomyProduceFunctionalUnits(first: $first, after: $after, where: $where, order: $order) {
      nodes {
        id
        code
        name
        state
        class
        category
        subcategory
        functionalUnit
        functionalUnitProxy
        transportCondition
        subcategoryId
        faoTradeId
        faoTrade
        faoTradeSource
        faoProductionId
        faoProduction
        faoProductionSource
        isVerified
        verificationComments
        verifiedByName
        verifiedByEmail
        verifiedOn
        lastPublishedDate
        lastUpdatedName
        updated
        researcherName
        researcherEmail
        created
        userEmail
      }
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
`
